import { ImportDialogButton } from "components/dialogs/ImportDialog/ImportDialogButton";
import React from "react";
import { TopToolbar, sanitizeListRestProps, useListContext } from "react-admin";

import { AddProductArticle } from "./AddProductArticle";

export const ProductArticlesActions = ({
	currentSort,
	className,
	resource,
	filters,
	displayedFilters,
	filterValues,
	permanentFilter,
	hasCreate,
	basePath,
	selectedIds,
	onUnselectItems,
	showFilter,
	maxResults,
	total,
	companyId,
	...rest
}) => {
	const { refetch } = useListContext();

	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				React.cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
				})}
			<ImportDialogButton
				label="osfc.buttons.import"
				dialogTitle="osfc.dialogs.product-articles-import-upload.title"
				uploadEndpoint="product-articles-upload"
				successMessage="osfc.dialogs.product-articles-import-upload.success"
				onSuccess={refetch}
				initialValues={{ company_id: companyId }}
				acceptTypes=".xlsx"
			/>
			<AddProductArticle companyId={companyId} isNeedRefresh={false} onCreated={refetch} />
		</TopToolbar>
	);
};
